<template>
  <el-container>
    <main class="page__container">
      <div class="container">
        <h2 class="page__title">Добавить клиента</h2>
        <el-form
          class="page__form"
          id="formCreateClient"
          :model="client"
          ref="form"
          :rules="rules"
          label-position="right"
          label-width="150px"
        >
          <el-row gutter="24">
            <el-col span="8">
              <el-form-item label="Завести в биллинг" prop="push_to_billing" v-if="operatorParameters.has_cameras_serial">
                <el-switch
                  v-model="client.push_to_billing"
                  :active-value="1"
                  :inactive-value="0"
                />
              </el-form-item>
            </el-col>
            <el-col span="16">
              <el-form-item label="Клиенту можно пошарить камеру любого оператора" prop="cross_sharing_enabled" v-if="canUseCrossSharing" label-width="auto">
                <el-switch
                  v-model="client.cross_sharing_enabled"
                  :active-value="1"
                  :inactive-value="0"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="Имя" prop="client_name">
            <el-input id="client_name" size="small" v-model="client.client_name" />
          </el-form-item>
          <el-form-item label="Логин" prop="login">
            <el-input id="login" size="small" v-model="client.login" />
          </el-form-item>
          <el-form-item label="Пароль" prop="password">
            <el-input id="password" size="small" v-model="client.password">
              <el-button @click="generatePassword" slot="append" type="primary">Создать пароль</el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="Номер телефона" prop="phone">
            <el-input id="phone" size="small" v-model="client.phone" />
          </el-form-item>
          <el-form-item label="Тип аккаунта" prop="account_type" v-if="operatorParameters.has_cameras_serial">
            <el-select
              size="small"
              placeholder="Выберите тип аккаунта"
              style="width: 100%"
              v-model="client.account_type"
            >
              <el-option key="1" label="Обычный" value="1"/>
              <el-option key="2" label="Бизнес" value="2"/>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </main>
    <el-footer class="page__active_bar">
      <el-button class="page__active_button" id="submit" icon="el-icon-check" type="primary" @click="submit">
        Добавить
      </el-button>
    </el-footer>
  </el-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { required, length, validatorSpace, validatorAllLatine } from "@/core/helpers/validators";
import OperatorService from "@/api/services/operator.service";

export default {
  name: "FormCreateClient",
  data() {
    return {
      canUseCrossSharing: 0,
      client: {
        client_name: "",
        login: "",
        password: "",
        account_type: null,
        push_to_billing: null,
        cross_sharing_enabled: 0,
      },
      rules: {
        client_name: [required(), length(4, 100)],
        login: [required(), length(5, 100), validatorSpace, validatorAllLatine],
        password: [required(), length(5, 100), validatorSpace, validatorAllLatine],
        account_type: [required()],
        push_to_billing: [required("number")],
        cross_sharing_enabled: [required("number")],
      },
    };
  },
  computed: {
    ...mapState("client", {
      operatorParameters: (state) => state.operatorParameters,
    }),
  },
  created() {
    OperatorService.getOperatorSettings()
      .then(data => {
        this.canUseCrossSharing = data.can_use_cross_sharing
      })
    this.getParameters();
  },
  methods: {
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.create(this.client)
            .then((id) => {
              this.$message({
                message: "Клиент успешно создан",
                type: "success",
              });
              this.$router.push({ name: "client:edit", params: { id } });
            })
            .catch((e) => {
              this.$message.error(e.response.data.error || "Ошибка при добавлении клиента");
            });
        }
        return valid;
      });
    },
    generatePassword() {
      const length = 8;
      const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let password = "";

      for (var i = 0, n = charset.length; i < length; ++i) {
        password += charset.charAt(Math.floor(Math.random() * n));
      }

      this.client.password = password;
    },
    ...mapActions("client", {
      create: "ADD_CLIENT",
      getParameters: "GET_OPERATOR_PARAMETERS",
    }),
  },
};
</script>
